// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "reactPlayerPreview" + "." + "142e25194c05085a27ef" + ".js";
};